import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";
import { publicService } from "../admin/services/publicService";

const API_PATH = process.env.REACT_APP_API_PATH;

const ShopDetails: React.FC = () => {
  // const productImages = [
  //   "/assets/img/shop/shop-d-big-1-1.png",
  //   "/assets/img/shop/shop-d-big-1-2.png",
  //   "/assets/img/shop/shop-d-big-1-3.png",
  //   "/assets/img/shop/shop-d-big-1-4.png",
  // ];

  // const products = [
  //   {
  //     id: 1,
  //     image: "/assets/img/product5/p-s-1-1.png",
  //     title: "Triumph Watch",
  //     price: "$755.00",
  //     isNew: false,
  //   },
  //   {
  //     id: 2,
  //     image: "/assets/img/product5/p-s-1-2.png",
  //     title: "Golden Line",
  //     price: "$955.00",
  //     isNew: true,
  //   },
  //   {
  //     id: 3,
  //     image: "/assets/img/product5/p-s-1-3.png",
  //     title: "Round Dial Semi",
  //     price: "$555.00",
  //     isNew: false,
  //   },
  //   {
  //     id: 4,
  //     image: "/assets/img/product5/p-s-1-4.png",
  //     title: "Black Dial Red",
  //     price: "$355.00",
  //     isNew: false,
  //   },
  // ];
const [selectedColor, setSelectedColor] = useState("orange");
  const [selectedImage, setSelectedImage] = useState();
  const [count, setCount] = useState(1);
   const [rating, setRating] = useState(0);
const [activeTab, setActiveTab] = useState("review");
 const [menuOpen, setMenuOpen] =  useState(false);

const { slug } = useParams();

const [product, setProduct] = useState<any>(null);

const [loading, setLoading] = useState(true);

const [relatedProducts, setRelatedProducts] = useState<any[]>([]);

// STATES ADD KARO
const [reviewText, setReviewText] = useState("");
const [reviewName, setReviewName] = useState("");
const [reviewEmail, setReviewEmail] = useState("");
const [reviewLoading, setReviewLoading] = useState(false);

useEffect(() => {
  getProductDetails();
}, [slug]);

const getProductDetails = async () => {
  try {
    setLoading(true);
    const currentSlug=slug;

    const response = await publicService.Getproductdetails(currentSlug!);

    const result = response;

    if (result.isSuccess) {
      setProduct(result.data);

      setRelatedProducts(result.data.relatedProducts || []);

      if (
        result.data.images &&
        result.data.images.length > 0
      ) {
        setSelectedImage(
          result.data.images[0].imageUrl
        );
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

const submitReview = async () => {
  try {

    if (rating === 0) {
      alert("Please select rating");
      return;
    }

    if (!reviewText) {
      alert("Please enter review");
      return;
    }

    // if (!reviewName) {
    //   alert("Please enter name");
    //   return;
    // }

    // if (!reviewEmail) {
    //   alert("Please enter email");
    //   return;
    // }

    setReviewLoading(true);

    const payload = {
  productID: product.productID,
  reviewText: reviewText,
  rating: rating
};

    const response = await publicService.addReview(payload);

    const result = await response;

    if (result.isSuccess) {

      alert("Review Submitted Successfully");

      setReviewText("");
      setReviewName("");
      setReviewEmail("");
      setRating(0);

      getProductDetails();
    }
    else {
      alert(result.message);
    }

  } catch (error) {
    console.log(error);
  } finally {
    setReviewLoading(false);
  }
};

  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main shop-details-main">
        <Header />
<link rel="stylesheet" href="/assets/css/shopdetail.css" />
        {/* HERO SECTION */}
        <section className="shop-hero">
          <div className="container">
            {/* <h1 className="shop-hero-title">PRODUCTS DETAILS</h1>

            <div className="shop-breadcrumb">
              <Link to="/">HOME</Link> {">>"} SHOP DETAILS
            </div> */}
                <div className="breadcumb-content">
              <h1 className="breadcumb-title">
              PRODUCTS DETAILS
              </h1>

              <div className="breadcumb-menu-wrap2">
                <ul className="breadcumb-menu">
                  <li>
                    <a  href="javascript:void(0)">HOME</a>
                  </li>

                  <li>SHOP DETAILS</li>
                </ul>
              </div>
            </div>
          </div>
          
        </section>

        {/* PRODUCT SECTION */}
        <section className="shop-details-section">
          <div className="container">
            <div className="row align-items-start">
              
              {/* THUMBNAILS */}
     <div className="col-lg-2">
  <Swiper
    direction="vertical"
    slidesPerView={4}
    spaceBetween={15}
    mousewheel={true}
    modules={[Mousewheel]}
    className="thumbnail-swiper"
  >
    {product?.images?.map((img: any, index: number) => (
  <SwiperSlide key={index}>
    <div
      onClick={() => setSelectedImage(img.imageUrl)}
      className={`thumbnail-box ${
        selectedImage === img.imageUrl
          ? "active"
          : ""
      }`}
    >
      <img
        src={`${API_PATH}/uploads/${img?.imageUrl}`}
        className="thumbnail-img"
        alt="thumb"
      />
    </div>
  </SwiperSlide>
))}
  </Swiper>
</div>

              {/* MAIN IMAGE */}
              <div className="col-lg-5 text-center">
                <div className="product-main-image-wrapper">
                  <img
  src={`${API_PATH}/uploads/${selectedImage}`}
  alt={product?.productName}
  className="product-main-image"
/>
                </div>
              </div>

              {/* PRODUCT CONTENT */}
              <div className="col-lg-5">
                <div className="product-content">

                  <p className="product-review">
  ★★★★★ | {product?.totalReviews} Review
</p>

                  <h2 className="product-name">
  {product?.productName}
</h2>

                  <h4 className="product-price">
  ₹{product?.sellingPrice}

  {/* <span className="old-price ms-2">
    ₹{product?.mrp}
  </span> */}

  <span className="stock-text">
    • {product?.isInStock ? "IN STOCK" : "OUT OF STOCK"}
  </span>
</h4>

                  <p className="product-description">
  {product?.shortDescription}
</p>

                  {/* QUANTITY + CART */}
                  <div className="cart-area">
                  

                   <div className="cart-box">
      
      {/* Quantity Button */}
      <div className="quantity-box">

      <span className="count">{String(count).padStart(2, "0")}</span>

      <div className="arrow-box">
       <div className="arrow-box">

  <button
    onClick={() => setCount(count + 1)}
    className="arrow-btn"
  >
    <i className="bi bi-chevron-up"></i>
  </button>

  <button
    onClick={() => count > 1 && setCount(count - 1)}
    className="arrow-btn"
  >
    <i className="bi bi-chevron-down"></i>
  </button>

</div>
      </div>

    </div>

      {/* Add To Cart Button */}
      <button className="vs-btn mx-3">
        ADD TO CART
      </button>

    </div>
                  </div>

                  <p className="wishlist-text">
                    ADD TO WISHLIST
                  </p>

                  <hr />

                  <p className="product-meta">
  <strong>CATEGORY :</strong>

  {product?.categoryName}
</p>

                  <p className="product-meta">
  <strong>BRAND :</strong>

  {product?.brandName}
</p>
                  <div className="share-section">


  <div className="social-icons">
    <a href="#" className="social-icon facebook">
      <i className="fab fa-facebook-f"></i>
    </a>

    <a href="#" className="social-icon instagram">
      <i className="fab fa-instagram"></i>
    </a>

    <a href="#" className="social-icon twitter">
      <i className="fab fa-twitter"></i>
    </a>

    <a href="#" className="social-icon linkedin">
      <i className="fab fa-linkedin-in"></i>
    </a>
  </div>
</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* REVIEW SECTION */}
    <section className="review-section">
  <div className="container">

    <div className="review-wrapper">

      {/* TAB BUTTONS */}
      <div className="review-tabs">

        <button
          className={`review-tab-btn ${
            activeTab === "details" ? "active-tab" : ""
          }`}
          onClick={() => setActiveTab("details")}
        >
          PRODUCT DETAILS
        </button>

        <button
          className={`review-tab-btn ${
            activeTab === "info" ? "active-tab" : ""
          }`}
          onClick={() => setActiveTab("info")}
        >
          ADDITIONAL INFORMATION
        </button>

        <button
          className={`review-tab-btn ${
            activeTab === "review" ? "active-tab" : ""
          }`}
          onClick={() => setActiveTab("review")}
        >
          REVIEW (0)
        </button>
      </div>

      {/* PRODUCT DETAILS */}
      {activeTab === "details" && (
        <div className="tab-content-area">
         <h3 className="desc-title">Why choose product?</h3>

          <p className="review-desc">
  {product?.description}
</p>
        </div>
      )}

      {/* ADDITIONAL INFO */}
      {activeTab === "info" && (
        <div className="tab-content-area">

          <h2 className="review-title">
            ADDITIONAL INFORMATION
          </h2>

          <div className="info-table">

            <div className="info-item">
  <span>SKU</span>

  <span>{product?.sku}</span>
</div>

<div className="info-item">
  <span>Category</span>

  <span>{product?.categoryName}</span>
</div>

<div className="info-item">
  <span>Brand</span>

  <span>{product?.brandName}</span>
</div>

          </div>
        </div>
      )}

      {/* REVIEW */}
      {activeTab === "review" && (
        <div className="tab-content-area">

          <h2 className="review-title">
  REVIEW FOR {product?.productName}
</h2>

          {product?.reviews?.map(
  (review: any, index: number) => (
    <div
      className="review-user"
      key={index}
    >
      <img
        src={`${API_PATH}/${review?.imageUrl}`}
        width="110"
        alt="review"
        className="smith-image"
      />

      <div style={{ width: "100%" }}>
        <h4 className="reviewer-name d-flex justify-content-between">

          <div className="smith">

            <span className="commented-on">
              {review.userName}
            </span>

            <span className="commented-on1">
  —
  {new Date(review.reviewDate)
    .toLocaleDateString("en-GB")}
</span>

          </div>

          <div className="star-rating2">
            <span className="star-icon">

              {[...Array(review.rating)].map(
                (_, i) => (
                  <i
                    key={i}
                    className="fa-solid fa-star"
                  ></i>
                )
              )}

            </span>
          </div>

        </h4>

        <p className="review-desc">
          {review.reviewText}
        </p>
      </div>
    </div>
  )
)}

          <h2 className="review-title">
            ADD A REVIEW
          </h2>
          <p className="review-desc">Your email address will not be published. Required fields are marked *</p>
      <div className="rating-stars">

      <i
        className={rating >= 1 ? "fa-solid fa-star star-active" : "fa-regular fa-star star-default"}
        onClick={() => setRating(1)}
      ></i>

      <i
        className={rating >= 2 ? "fa-solid fa-star star-active" : "fa-regular fa-star star-default"}
        onClick={() => setRating(2)}
      ></i>

      <i
        className={rating >= 3 ? "fa-solid fa-star star-active" : "fa-regular fa-star star-default"}
        onClick={() => setRating(3)}
      ></i>

      <i
        className={rating >= 4 ? "fa-solid fa-star star-active" : "fa-regular fa-star star-default"}
        onClick={() => setRating(4)}
      ></i>

      <i
        className={rating >= 5 ? "fa-solid fa-star star-active" : "fa-regular fa-star star-default"}
        onClick={() => setRating(5)}
      ></i>

    </div>
          <textarea
  className="form-control mt-4"
  rows={6}
  placeholder="Your Review *"
  value={reviewText}
  onChange={(e) =>
    setReviewText(e.target.value)
  }
/>

          <div className="row mt-4">

            {/* <div className="col-md-6">
              <input
  className="form-control"
  placeholder="Your Name *"
  value={reviewName}
  onChange={(e) =>
    setReviewName(e.target.value)
  }
/>
            </div> */}

            {/* <div className="col-md-6">
              <input
  className="form-control"
  placeholder="Your Email *"
  value={reviewEmail}
  onChange={(e) =>
    setReviewEmail(e.target.value)
  }
/>
            </div> */}

          </div>

          <button
  className="vs-btn submit-btn"
  onClick={submitReview}
  disabled={reviewLoading}
>
  {reviewLoading
    ? "SUBMITTING..."
    : "SUBMIT"}
</button>
        </div>
      )}

    </div>
  </div>
</section>

        {/* RELATED PRODUCTS */}
        <section className="related-product-section">
          <div className="container text-center">

            <p className="section-subtitle">
              HIGHLY RECOMMEND
            </p>

            <h2 className="section-title">
              TOP RELATED PRODUCTS
            </h2>

            <div className="row">
              {relatedProducts.map((product: any) => (
  <div
    className="col-xl-3 col-lg-3 col-md-3"
    key={product?.productID}
  >
    <div className="product-style2 version3">

      <div className="product-img">
        <img
          className="img"
          src={`${API_PATH}/uploads/${product?.imageUrl}`}
          alt={product?.productName}
        />
      </div>

      <h3 className="product-title">
        <Link
          to={`/shop-details/${product?.productSlug}`}
        >
          {product?.productName}
        </Link>
      </h3>

      <span className="product-price">
        <span className="product-price__number">
          ₹{product?.sellingPrice}
        </span>

        <button className="product-cart">
          Add To Cart
        </button>
      </span>
    </div>
  </div>
))}
            </div>
          </div>
        </section>

        <Footer />
      </main>

      <ScrollToTop />
    </>
  );
};

export default ShopDetails;